// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".my-label{width:9.166667rem}.label_right,.my-label{text-align:right!important}.label_right{width:10.677083rem}", ""]);
// Exports
module.exports = exports;
